document.addEventListener('DOMContentLoaded', function() {
  const nav = document.querySelector('.ring-story-nav');
  const navItems = document.querySelectorAll('.ring-story-nav-item');
  const contents = document.querySelectorAll('.ring-story-content');
  
  // Add arrow icon to navigation
  const arrowIcon = document.createElement('div');
  arrowIcon.className = 'arrow-icon';
  nav.appendChild(arrowIcon);
  
  // Initialize first items as active
  if (navItems.length > 0) {
    navItems[0].classList.add('active');
    contents[0].classList.add('active');
  }
  
  // Mobile dropdown toggle
  navItems.forEach((item, index) => {
    item.addEventListener('click', function(e) {
      if (window.innerWidth < 750) {
        if (item.classList.contains('active')) {
          // Only toggle dropdown when clicking active item
          nav.classList.toggle('active');
        } else {
          // Switch active item without changing order
          navItems.forEach(navItem => navItem.classList.remove('active'));
          contents.forEach(content => content.classList.remove('active'));
          
          item.classList.add('active');
          contents[index].classList.add('active');
          nav.classList.remove('active');
        }
      } else {
        // Desktop behavior
        navItems.forEach(navItem => navItem.classList.remove('active'));
        contents.forEach(content => content.classList.remove('active'));
        
        item.classList.add('active');
        contents[index].classList.add('active');
      }
    });
  });
  
  // Close dropdown when clicking outside
  document.addEventListener('click', function(e) {
    if (window.innerWidth < 750 && !nav.contains(e.target)) {
      nav.classList.remove('active');
    }
  });

  // // // // // // // // // 

    // Swiper initialization
if (document.querySelector('.gallery-container')) {
  var swiper = new Swiper(".gallery-container", {
    slidesPerView: 2,
    spaceBetween: 16,
    pagination: {
      el: ".gallery-container .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 24,
        pagination: false, 
      },
    },
  });
}

  // Connection Sections Swiper initialization
if (document.querySelector('.connection-sections')) {
  var connectionSwiper = new Swiper(".connection-sections", {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: ".connection-sections .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 24,
        pagination: false,
      },
    },
  });
}

  // Legacy Sections Swiper initialization
if (document.querySelector('.legacy-sections')) {
  var connectionSwiper = new Swiper(".legacy-sections", {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: ".legacy-sections .swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 24,
        pagination: false,
      },
    },
  });
}

// 
// 
  // 

    // Video Modal Functionality
const videoModal = document.getElementById('videoModal');
const videoPlayer = document.getElementById('videoPlayer');
const videoTriggers = document.querySelectorAll('[data-video-trigger]');
const modalClose = document.querySelector('.video-modal-close');
const modalOverlay = document.querySelector('.video-modal-overlay');

// Function to create video embed
function createVideoEmbed(videoData) {
  const hiddenVideo = videoData.querySelector('.hidden-video');
  
  if (hiddenVideo) {
    // Clone the hidden video element
    const videoClone = hiddenVideo.cloneNode(true);
    videoClone.classList.remove('hidden-video');
    videoClone.style.width = '100%';
    videoClone.style.height = '100%';
    videoClone.style.display = 'block';
    
    return videoClone.outerHTML;
  }
  
  return '';
}

// Function to open modal
function openVideoModal(videoData) {
  if (!videoData) return;
  
  const embedHtml = createVideoEmbed(videoData);
  if (embedHtml) {
    videoPlayer.innerHTML = embedHtml;
    videoModal.classList.add('active');
    document.body.classList.add('modal-open');
    
    // Prevent scrolling on background
    document.body.style.top = `-${window.scrollY}px`;

    // Hide epb_container behind modal
    const epbContainer = document.getElementById('epb_container');
    if (epbContainer) {
      epbContainer.style.zIndex = '-1';
    }
    
    // Auto-play video after modal opens
    setTimeout(() => {
      const video = videoPlayer.querySelector('video');
      if (video) {
        video.play().catch(e => {
          console.log('Auto-play blocked by browser:', e);
        });
      }
    }, 300);
  }
}

// Function to close modal
function closeVideoModal() {
  videoModal.classList.remove('active');
  document.body.classList.remove('modal-open');
  
  // Restore scroll position
  const scrollY = document.body.style.top;
  document.body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);

   // Restore epb_container z-index
  const epbContainer = document.getElementById('epb_container');
  if (epbContainer) {
    epbContainer.style.zIndex = '';
  }
  
  // Clear video content to stop playback
  setTimeout(() => {
    videoPlayer.innerHTML = '';
  }, 300);
}

// Event listeners for video triggers
videoTriggers.forEach(trigger => {
  trigger.addEventListener('click', function() {
    const videoData = this.querySelector('.video-data');
    openVideoModal(videoData);
  });
});

// Event listeners for closing modal
if (modalClose) {
  modalClose.addEventListener('click', closeVideoModal);
}

if (modalOverlay) {
  modalOverlay.addEventListener('click', closeVideoModal);
}

// Close modal with Escape key
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && videoModal.classList.contains('active')) {
    closeVideoModal();
  }
});

// Handle window resize
window.addEventListener('resize', function() {
  if (videoModal.classList.contains('active')) {
    // Adjust modal positioning if needed
  }
});
});